import { JsonPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { APP_ENVIRONMENT } from '@app/shared/tokens';
import { select } from '@ngxs/store';

import { FormatDatePipe } from '../../pipes/format-date.pipe';

@Component({
    selector: 'shared-build-info',
    template: `
        @if (show()) {
        <div class="build-info">
            <span [ngClass]="{ 'mismatched-version': mismatchedVersion() }"
                >{{ devicePixelRatio() }}dpr {{ env.buildVersion }}-{{ buildLabel() }} ({{
                    env.buildDate | formatDate
                }})</span
            >
        </div>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,

    styles: [
        `
            .build-info {
                pointer-events: none;
                opacity: 0.5;
                position: absolute;
                bottom: 0;
                right: 0;
                font-size: 12px;
                z-index: 999;

                .mismatched-version {
                    color: red;
                    font-weight: bold;
                    animation: blinkAnimation 4s infinite linear;
                }
            }

            @keyframes blinkAnimation {
                0% {
                    opacity: 1;
                }
                50% {
                    opacity: 0;
                }
                100% {
                    opacity: 1;
                }
            }
        `,
    ],
    imports: [FormatDatePipe, NgClass],
})
export class BuildInfoComponent {
    env = inject(APP_ENVIRONMENT);

    devicePixelRatio = computed(() => window.devicePixelRatio);
    mismatchedVersion = computed(() => {
        const isSupport =
            this.buildLabel()?.includes('debug-support') && this.env.privateContainerName.includes('support');
        const isProd = this.buildLabel()?.includes('debug-prod') && this.env.privateContainerName.includes('production');

        return !isSupport && !isProd;
    });

    show = select(state => state.debug?.isEnabled);
    buildLabel = select(state => state.debug?.apiVersion);
}
